var createElementIcon = function (createElement, icon) {
    return createElement('i', {
        attrs: {
            class: icon
        },
        style: {
            // fontSize: '80px',
            // marginBottom: '2rem',
            // display: icon == 'none' ? 'none': ''
            'font-Size': '80px',
            'margin-Bottom': '2rem',
            display: icon == 'none' ? 'none' : ''
        },
        props: {
            icon: 'el-icon-success'
        }
    })
}
var createElementImage = function (createElement, image) {
    return createElement('img', {
        attrs: {
            src: image
        },
        style: {
            width: '6.6rem',
            height: '6.6rem',
            // marginBottom: '2rem',
            'margin-Bottom': '2rem',
        },
        props: {
            icon: 'el-icon-success'
        }
    })
}
var createElementText = function (createElement, text) {
    return createElement('div', {
        domProps: {
            innerHTML: text
        },
        style: {
            // paddingBottom: '2rem'
            'padding-Bottom': '2rem'

        },
        props: {
            text: '操作成功'
        }
    })
}

function createEle(data) {
    let {h, image, icon, text, duration} = data
    let _createElement = h.$createElement
    let $el = h.$el
    let domObj;
    if (image) {
        domObj = _createElement(
            'div', // 一个 HTML 标签名、组件选项对象，或者resolve 了上述任何一种的一个 async 函数。必填项。 {String | Object | Function}
            {
                attrs: {
                    id: 'toast',
                }
            }, //一个与模板中属性对应的数据对象。可选  {Object}
            [
                createElementImage(_createElement, image),
                createElementText(_createElement, text || '操作成功')
            ]
        )
    } else {
        domObj = _createElement(
            'div', // 一个 HTML 标签名、组件选项对象，或者resolve 了上述任何一种的一个 async 函数。必填项。 {String | Object | Function}
            {
                attrs: {
                    id: 'toast',
                }
            }, //一个与模板中属性对应的数据对象。可选  {Object}
            [
                createElementIcon(_createElement, icon || 'el-icon-success'),
                createElementText(_createElement, text || '操作成功')
            ]
        )
    }
    let results = render(domObj)
    $el.appendChild(results)
    var times = duration || 1500
    setTimeout(() => {
        var child = document.getElementById('toast')
        if (child)
            $el.removeChild(child)
    }, times)
}

function render(domObj) {
    let el = document.createElement(domObj.tag);
    let keys = Object.assign(domObj.data)
    for (let i in keys) {
        if (i == 'style') {
            setAttr(el, i, keys[i]);
        } else {
            for (let key in keys[i]) {
                setAttr(el, key, keys[i][key]);
            }
        }
    }
    if (domObj.children) {
        domObj.children.forEach(child => {
            child = render(child)
            el.appendChild(child);
        });
    }
    return el
}

// 设置属性
function setAttr(node, key, value) {
    switch (key) {
        case 'value':
            if (node.tagName.toLowerCase() === 'input' ||
                node.tagName.toLowerCase() === 'textarea') {
                node.value = value;
            } else {
                node.setAttribute(key, value);
            }
            break;
        case 'style':
            // 直接赋值行内样式
            var str = ''
            for (let s in value) {
                str += s + ':' + value[s] + ';'
            }
            node.setAttribute(key, str)
            break;
        case 'innerHTML':
            node.innerHTML = value;
            break;
        default:
            node.setAttribute(key, value);
            break;
    }
}

export default createEle
